// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"styles_sectionContainer__1U6gp"};